module.exports = __webpack_public_path__ + "static/img/0-4Risk.9c822265.jpg";